
import LoginPage from "@/pages/LoginPage.vue";
import TinhChiTietPage from "@/pages/TinhChiTietPage.vue";
import DanhSachDeTai from "@/pages/DanhSachDeTai.vue";

import { useStore } from 'vuex'
import { computed } from 'vue'

export default {
  components: {
    LoginPage,
    DanhSachDeTai,
  },
  setup(){
    const store = useStore();
    const isLoggedIn = computed(() => !!store.state.token);

    return {
      isLoggedIn
    }
  }
}
